import BackstageLayout from "./BackstageLayout"

export default BackstageLayout
